// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2FgnR","title":"ClientInsurance_title__3CEjS","itemText":"ClientInsurance_itemText__2CBya"};